// Operator-facing message builder for the OrderDetailModal "add line item"
// flow. Routes the raw Axios/network error through `extractApiErrorMessage`
// so the FastAPI `detail` is surfaced when present, then prefixes with the
// item code so the user knows which product the failure refers to.
//
// Lives in its own module so it can be tested in isolation and so the
// component file remains lint-clean under react-refresh/only-export-components.

import { extractApiErrorMessage } from '../../utils/emailActionUtils';

export function formatAddLineItemError(err: unknown, itemCode: string): string {
  const message = extractApiErrorMessage(
    err,
    'Could not add this product to the order. Please try again.',
  );
  return `Failed to add ${itemCode}: ${message}`;
}

// Operator-facing message for a failed product-catalog search in the same
// inline "add line item" flow. Without it a 5xx / 401 / network failure was
// swallowed and rendered as "No products found", indistinguishable from a
// genuinely empty result (kanban c8af49e6, sibling of PR #963).
export function formatProductSearchError(err: unknown): string {
  const message = extractApiErrorMessage(
    err,
    'Could not search the product catalog. Please try again.',
  );
  return `Product search failed: ${message}`;
}
